module.exports = __webpack_public_path__ + "static/media/airbaltic_club.4a0ae94b.svg";